import apiClient from './api';

// L'identité n'est plus transportée par le client : le backend l'écrit dans un
// cookie de session signé, que le navigateur renvoie tout seul.
export const login = (email, password) => apiClient.post(`/authentification/login`, { email, password });

export const getSession = () => apiClient.get(`/authentification/session`);

export const logout = () => apiClient.post(`/authentification/logout`);
